import RestService from "@/services/RestService";

function clientTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "Europe/Kyiv";
  } catch (error) {
    return "Europe/Kyiv";
  }
}

function getActiveTheme(etag = "", previews = {}) {
  const headers = {
    "X-Client-Timezone": clientTimezone(),
  };
  if (etag) {
    headers["If-None-Match"] = etag;
  }
  return RestService.sendReq(
    "get",
    "themes/active",
    {
      ...(previews.monthly ? { preview_monthly: previews.monthly } : {}),
      ...(previews.holiday ? { preview_holiday: previews.holiday } : {}),
    },
    {
    headers,
    validateStatus: (status) =>
      (status >= 200 && status < 300) || status === 304,
    }
  );
}

function getPreferences() {
  return RestService.sendReq("get", "user/theme-preferences", {});
}

function updatePreferences(preferences) {
  return RestService.sendReq(
    "patch",
    "user/theme-preferences",
    preferences
  );
}

export default {
  getActiveTheme,
  getPreferences,
  updatePreferences,
};
